import { Button, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { SIDE_PADDING, TOP_PADDING } from "../../../app/theme/muiTheme";
import Footer from "../../common/Footer";
import { useNavigate } from "react-router-dom";
import { CONTACT } from "../../../app/api/routes";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "60vh",
    paddingTop: TOP_PADDING,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    paddingBottom: TOP_PADDING,
  },
  headingtxt: {
    textAlign: "center",
    fontSize: 30,
    paddingBottom: "5%",
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  projectcontainer: {
    paddingTop: "2%",
    paddingRight: "4%",
    paddingLeft: "4%",
    [theme.breakpoints.down("md")]: {
      paddingBottom: "5%",
    },
  },
  projectheadingtxt: {
    paddingBottom: "4%",
    fontSize: 30,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  projectdesctxt: {
    fontSize: 18,
    paddingBottom: "4%",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  projectmain: {
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 10,
    borderColor: theme.palette.secondary.main,
    overflow: "hidden",
  },
  image: {
    width: "100%",
  },
}));

const SocialInitiatives = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const websiteHandler = () => {
    navigate(CONTACT);
  };

  return (
    <>
      <div className={classes.root}>
        <Grid container justifyContent={"center"}>
          <Grid xs={12} item>
            <Typography className={classes.headingtxt}>
              My Social Initiatives
            </Typography>
          </Grid>
          <Grid xs={12} md={8} item container className={classes.projectmain}>
            <Grid xs={12} md={6} item>
              <img
                alt="posh"
                src="/images/poshmain.svg"
                className={classes.image}
              />
            </Grid>
            <Grid xs={12} md={6} item className={classes.projectcontainer}>
              <Typography className={classes.projectheadingtxt}>
                Project Posh
              </Typography>
              <Typography className={classes.projectdesctxt}>
                Project POSH+ is an international initiative for prevention of
                sexual harassment and gender discrimination, having its presence
                in eight countries across Asia, Europe and Africa.
              </Typography>
              <Button onClick={websiteHandler}>Contact Us -></Button>
            </Grid>
          </Grid>
          <Grid xs={12} item style={{ height: 20 }}></Grid>

          <Grid xs={12} md={8} item container className={classes.projectmain}>
            <Grid xs={12} md={6} item>
              <img
                alt="posh"
                src="/images/legalrakshamain.svg"
                className={classes.image}
              />
            </Grid>
            <Grid xs={12} md={6} item className={classes.projectcontainer}>
              <Typography className={classes.projectheadingtxt}>
                Legal Raksha{" "}
              </Typography>
              <Typography className={classes.projectdesctxt}>
                LegalRaksha is a powerful legal assistance service for Women and
                LGBTQ+. LegalRaksha eliminates the barriers that prevent women
                and LGBTQ+ from availing professional legal consultation and
                empowers them to protect their fundamental rights.
              </Typography>
              <Button onClick={websiteHandler}>Contact Us -></Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </>
  );
};

export default SocialInitiatives;
